export default [
  { label: 'Select a state...', value: '' },
  { label: 'AE', value: 'AE' },
  { label: 'AK', value: 'AK' },
  { label: 'AL', value: 'AL' },
  { label: 'AP', value: 'AP' },
  { label: 'AR', value: 'AR' },
  { label: 'AZ', value: 'AZ' },
  { label: 'CA', value: 'CA' },
  { label: 'CH', value: 'CH' },
  { label: 'CO', value: 'CO' },
  { label: 'CT', value: 'CT' },
  { label: 'DC', value: 'DC' },
  { label: 'DE', value: 'DE' },
  { label: 'FL', value: 'FL' },
  { label: 'GA', value: 'GA' },
  { label: 'HI', value: 'HI' },
  { label: 'ID', value: 'ID' },
  { label: 'IL', value: 'IL' },
  { label: 'IN', value: 'IN' },
  { label: 'KS', value: 'KS' },
  { label: 'KY', value: 'KY' },
  { label: 'LA', value: 'LA' },
  { label: 'MA', value: 'MA' },
  { label: 'MD', value: 'MD' },
  { label: 'ME', value: 'ME' },
  { label: 'MI', value: 'MI' },
  { label: 'MN', value: 'MN' },
  { label: 'MO', value: 'MO' },
  { label: 'MS', value: 'MS' },
  { label: 'MT', value: 'MT' },
  { label: 'NC', value: 'NC' },
  { label: 'ND', value: 'ND' },
  { label: 'NH', value: 'NH' },
  { label: 'NJ', value: 'NJ' },
  { label: 'NM', value: 'NM' },
  { label: 'NV', value: 'NV' },
  { label: 'NY', value: 'NY' },
  { label: 'OH', value: 'OH' },
  { label: 'OK', value: 'OK' },
  { label: 'OR', value: 'OR' },
  { label: 'PA', value: 'PA' },
  { label: 'RI', value: 'RI' },
  { label: 'SC', value: 'SC' },
  { label: 'SD', value: 'SD' },
  { label: 'TN', value: 'TN' },
  { label: 'TX', value: 'TX' },
  { label: 'UT', value: 'UT' },
  { label: 'VA', value: 'VA' },
  { label: 'VT', value: 'VT' },
  { label: 'WA', value: 'WA' },
  { label: 'WI', value: 'WI' },
  { label: 'WV', value: 'WV' },
  { label: 'WY', value: 'WY' },
  { label: 'Australia', value: 'Australia' },
  { label: 'Bermuda', value: 'Bermuda' },
  { label: 'France', value: 'France' },
  { label: 'Guam', value: 'Guam' },
  { label: 'Japan', value: 'Japan' },
  { label: 'Peru', value: 'Peru' },
  { label: 'Switzerland', value: 'Switzerland' },
  { label: 'Other', value: 'Other' }
]
